<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Event summary</span></h4>
                    Click on particular column number to drill down into seeing what kind of events has been received for particular event type
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{'loading-mask': loading}">
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>
                      <div style="float:left; margin-top: 10px">
                                <button @click="modifyDay(-1)" class="btn btn-primary pull-left" style="margin: 10px">Previous day</button>
                                <datetime type="date" :input-class="'form-control'" :placeholder="'Choose `from` date'" style="margin-left: 20px; float:left; width:200px" v-model="from"></datetime>
                                <button @click="modifyDay(1)" class="btn btn-primary" style="margin: 10px">Next day</button>

                                Show domain with at least number of events:
                                <input
                                placeholder="Filter by number of events"
                                style="border: 1px solid grey; margin-top: 10px; margin: 10px"
                                type="number"
                                min="1"
                                class=""
                                v-model="limit"
                                />
                                <button
                                @click="load"
                                class="btn btn-primary pull-right"
                                style="margin: 10px"
                                >
                                Load
                                </button>
                            </div>
                            <table class="table table-striped table-xs" style="min-height: 100px">
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Domain</th>
                                        <th>Event sum</th>
                                        <th>Delivered</th>
                                        <th>Deferred</th>
                                        <th>Bounce</th>
                                        <th>Spamreport</th>
                                        <th>Blocked</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="r,k in rows">
                                        <td style="width:10px">{{k+1}}</td>
                                        <td>{{r.domain}}</td>
                                        <td>{{r.sum}}</td>
                                        <td>{{r.event_count.delivered||0}}</td>
                                        <td><router-link :to="{name:'event_summary_domain', params: {domain: r.domain, day: (new Date(from)).getTime(), event: 'deferred'}}">{{r.event_count.deferred||0}}</router-link></td>
                                        <td><router-link :to="{name:'event_summary_domain', params: {domain: r.domain, day: (new Date(from)).getTime(), event: 'bounced'}}">{{r.event_count.bounced||0}}</router-link></td>
                                        <td><router-link :to="{name:'event_summary_domain', params: {domain: r.domain, day: (new Date(from)).getTime(), event: 'spam'}}">{{r.event_count.spam||0}}</router-link></td>
                                        <td><router-link :to="{name:'event_summary_domain', params: {domain: r.domain, day: (new Date(from)).getTime(), event: 'blocked'}}">{{r.event_count.blocked||0}}</router-link></td>
                                        <td>
                                        </td>
                                    </tr>
                                    <h2 v-if="rows.length === 0"> </h2>
                                </tbody>
                            </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
let queryDebounce
import moment from 'moment'
import EventBus from '@/event_bus'
export default {
    data() {
        return {
            showUpload: false,

            from: moment().toISOString(),

            rows: [],
            loading: true,
            adding: false,
            limit: 25,
            offset: 0,
            count: 0,
            query: null,
            limit:1000
        }
    },
    watch: {
        from(){
            this.load()
        }
    },
    computed: {
        pages() {
            if (this.count <= this.limit) {
                return 1
            }

            return Math.ceil(this.count / this.limit)
        },
        page() {
            if (this.offset === 0) {
                return 1
            }
            return (this.offset / this.limit) + 1 || 1
        },
    },
    methods: {
        modifyDay(d){
            this.from = moment(this.from).add(d, 'day').toISOString()
        },
        prevPage() {
            this.offset -= 25
            this.load()
        },
        nextPage() {
            this.offset += 25
            this.load()

        },
        load() {
            this.loading = true
            this.$api.getReq(`event_summary/`+moment(this.from).toDate().getTime(), {limit: this.limit}).then(res => {
                this.rows = res.body.data
                this.count = res.body.data.length
                this.loading = false
            })
        }
    },
    destroyed() {},
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/EventSummary.vue